// extracted by mini-css-extract-plugin
export var label = "_hz-2";
export var slideContainer = "_hz-0";
export var slider = "_hz-1";